import * as Yup from 'yup'
import { INSURANCE_COVERAGE_MAX_FILES } from './insuranceCoverage.constants'

const maxFilesErrorMessage = `You've reached the maximum file upload limit (${INSURANCE_COVERAGE_MAX_FILES} files).`

const requiredProofFileMessage = 'Please upload required file.'

const proofFilesSchema = () =>
  Yup.array()
    .nullable()
    .max(INSURANCE_COVERAGE_MAX_FILES, maxFilesErrorMessage)
    .min(1, requiredProofFileMessage)
    .test('required-files', requiredProofFileMessage, (value) => {
      return value !== null && value !== undefined && value.length > 0
    })

export const createInsuranceCoverageSchema = (requireDocumentUploadWhenOptedIn?: boolean) => {
  return Yup.object({
    type: Yup.string()
      .oneOf(['gigsafe', 'own', 'skip'], 'Selecting an answer is required.')
      .required('Selecting an answer is required.'),
    files: Yup.array()
      .nullable()
      .when('type', {
        is: 'own',
        then: () => proofFilesSchema(),
        otherwise: (schema) =>
          schema.when('type', {
            is: 'skip',
            then: () => Yup.array().nullable().notRequired(),
            otherwise: () =>
              requireDocumentUploadWhenOptedIn
                ? proofFilesSchema()
                : Yup.array()
                    .nullable()
                    .max(INSURANCE_COVERAGE_MAX_FILES, maxFilesErrorMessage)
                    .notRequired(),
          }),
      }),
  })
}
